import { call, put, select, takeLatest } from 'redux-saga/effects';
import { RootState } from 'rootReducer';
import { Role } from 'entities/Roles';

import { Trip, TripService, tripStatuses } from '../../../../../entities/Trip';
import { TripOrderingTable } from '../../../global/interfaces';
import { getTripsSuccess, getTripsError } from './actions';
import { GET_ORDERING_TRIPS_REQUEST, GET_ORDERING_UNLOADING_TRIPS_REQUEST } from './constants';

function* createEventSaga(isLoadingTrips: boolean) {
  try {
    const trips: Trip[] = yield call(isLoadingTrips ? TripService.getTrips : TripService.getUnloadingTrips);

    const role: Role = yield select((state: RootState) => state.authModuleReducer.authReducer.role);

    const operatingProcedure = role.branches.find(
      (branch) => branch?.id === JSON.parse(localStorage.getItem('branchId') || 'null')?.id,
    )?.operatingProcedure;

    let allowedTrips = [
      tripStatuses.noOrder,
      tripStatuses.parkingInLine,
      tripStatuses.waitingOrder,
      tripStatuses.parking,
      tripStatuses.waitingInvoice,
      tripStatuses.onPause,
      tripStatuses.waiting,
      tripStatuses.downloading,
      tripStatuses.unloading,
    ];

    if (operatingProcedure === 'Порядок 2') {
      allowedTrips = [
        tripStatuses.create,
        tripStatuses.parkingInLine,
        tripStatuses.waitingOrder,
        tripStatuses.waiting,
        tripStatuses.downloading,
        tripStatuses.parking,
        tripStatuses.waitingInvoice,
        tripStatuses.onPause,
        tripStatuses.unloading,
      ];
    } else if (operatingProcedure === 'Порядок 3') {
      allowedTrips = [
        tripStatuses.create,
        tripStatuses.parkingInLine,
        tripStatuses.waitingOrder,
        tripStatuses.waiting,
        tripStatuses.downloading,
        tripStatuses.parking,
        tripStatuses.waitingInvoice,
        tripStatuses.onPause,
        tripStatuses.unloading,
        tripStatuses.waitingDeparture,
      ];
    }

    const tripsFiltered = trips.filter((t) => allowedTrips.includes(t.statusId));

    const tripsId7 = tripsFiltered.filter((t) => t.statusId === tripStatuses.onPause);
    const tripsId9 = tripsFiltered.filter((t) => t.statusId === tripStatuses.noOrder);
    const tripsId2 = tripsFiltered.filter((t) => t.statusId === tripStatuses.parkingInLine);
    const tripsId21 = tripsFiltered.filter((t) => t.statusId === tripStatuses.waitingOrder);
    const tripsId5 = tripsFiltered.filter((t) => t.statusId === tripStatuses.parking);
    const tripsId51 = tripsFiltered.filter((t) => t.statusId === tripStatuses.waitingInvoice);
    const tripsId3 = tripsFiltered.filter((t) => t.statusId === tripStatuses.waiting);
    const tripsId4 = tripsFiltered.filter((t) => t.statusId === tripStatuses.downloading);
    const tripsId1 = tripsFiltered.filter((t) => t.statusId === tripStatuses.create);
    const tripsId10 = tripsFiltered.filter((t) => t.statusId === tripStatuses.unloading);
    const tripsId6 = tripsFiltered.filter((t) => t.statusId === tripStatuses.waitingDeparture);

    const tripsToDisplay: Trip[] = [
      ...tripsId1,
      ...tripsId2,
      ...tripsId21,
      ...tripsId5,
      ...tripsId51,
      ...tripsId7,
      ...tripsId9,
      ...tripsId3,
      ...tripsId4,
      ...tripsId10,
      ...tripsId6,
    ];

    const formattedTrips: TripOrderingTable[] = yield call(TripService.formatTripsForOrderingTable, tripsToDisplay);
    yield put(getTripsSuccess(formattedTrips));
  } catch (error: any) {
    yield put(getTripsError(error));
  }
}

export function* tripsTabSagaWatcher() {
  yield takeLatest(GET_ORDERING_TRIPS_REQUEST, createEventSaga, true);
}

export function* unloadingTripsTabSagaWatcher() {
  yield takeLatest(GET_ORDERING_UNLOADING_TRIPS_REQUEST, createEventSaga, false);
}
